import { ModalContainer } from 'src/components/ModalContainer';
import { MacrosListStep } from 'src/pages/Conversations/Chat/Macros/macros-modal/macros-list-step';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';

export const MacrosModal = () => {
  const { isOpened, modalProps } = useModalState(Modals.MacrosModal);
  const { closeModal } = useModalMethods(Modals.MacrosModal);

  if (!modalProps?.conversation) {
    return null;
  }

  const { conversation, onMacroSelected } = modalProps;

  return (
    <ModalContainer
      open={isOpened}
      size="large"
      onClose={closeModal}
      data-testid="macros-modal"
    >
      <MacrosListStep
        conversationId={conversation.id}
        partnerId={conversation.partnerId ?? null}
        onMacroSelected={onMacroSelected}
      />
    </ModalContainer>
  );
};
